/**
 * Main settings file for the app
 */

// All current brands
const allBrands = {
    whizzoh: {
        pwaBrandName: "Whizzoh",
        whitelabel: false,
        serviceDbSurge: "E5D28813-3AAA-4B89-BC12-2B0A3ED53846"
    },
    ignition: {
        pwaBrandName: "SafeBase",
        serviceDbSurge: "B5B206B1-BCBA-4B79-9F9B-E926BB18BF41",
        scheme: {
            schemeId: "17097102-0139-4D53-892E-0B82FCCBCB2E",
            clientId: "1B2A3A5B-2336-42E4-846E-BBD4759D483E",
            schemeName: "SafeBase",
            schemeFriendlyName: "SafeBase",
            callCenterNumber: "0861 115 353",
            startUrl: "service-request.html"
        }
    },
    assistsa: {
        pwaBrandName: "AssistSA",
        scheme: {
            schemeId: "04497670-C288-4C8B-A23B-EB5F159616AB",
            clientId: "D7097E45-AE7E-45B9-A0D9-94E8174741A8",
            schemeName: "AssistSA",
            schemeFriendlyName: "Assist SA",
            callCenterNumber: "0861 115 353"
        }
    },
};
// Add brand below to disable dark mode
const disableDarkMode = [
    "outsurance",
    'ignition'
];

/**
 * Edit below values
 */
// Control branding 
const pwaBrand = 'ignition'; 
// Environment 
const pwaDomain = 'https://prodza.assistsa.co.za/';
// App base URL
const pwaRoot = pwaDomain + 'InteractiveWebsite/Ignition/SafeBase/';
// App type  
const pwaType = 'End User';
// PWA description
const pwaDescription = '';
// Dark mode
const darkMode = disableDarkMode.includes(pwaBrand.toLowerCase()) ? false : true;
// Toggle news feed
const showNewsFeed = false;  
/**
 * END 
 */

// Get active brand
const activeBrand = getBrand(pwaBrand, allBrands);
if (!activeBrand)
{
    const errorMsg = `App brand config failed, no brand named '${pwaBrand}' found`;
    throw new Error(errorMsg);
}
// Branding display name
const pwaBrandName = activeBrand.pwaBrandName;
const pwaBrandNameCaps = pwaBrandName.charAt(0).toUpperCase() + pwaBrandName.slice(1);
const defaultScheme = {
    schemeId: 0,
    clientId: 0,
    schemeName: pwaBrand,
    schemeFriendlyName: pwaBrandName
};

const offCanvasTemplates = {
    // Off-canvas elements
    globalMenus: 'menus/menus.ejs',
    jobMenus: 'menus/job-menus.ejs',
    paymentMenu: 'menus/payment-menus.ejs',
    paymentFrame: 'menus/payment-frame.ejs',
    bankCardMenus: 'menus/bankcard-menus.ejs',
    bidMenus: 'menus/bids-menus.ejs',
    quoteMenus: 'menus/quote-menus.ejs',
    chatMenus: 'menus/chat-menus.ejs',
    jobRatingMenus: 'menus/rating-menus.ejs',
    inboxMenus: 'menus/inbox-menus.ejs',
    endUserAddressMenus: 'menus/enduser-address-menus.ejs',
    personalDetailMenus: 'menus/personal-details-menus.ejs',
    unsignedDocs: 'menus/unsigned-doc-menus.ejs',
    invoiceMenus: 'menus/invoice-menus.ejs',
    serviceRequestMenus: 'menus/service-request-menus.ejs',
    termsConditions: 'menus/terms-conditions.ejs',
    assessmentMenus: 'menus/assessment-type-menus.ejs',
    // Notification templates
    notifications: 'notifications/notifications.ejs',
    // Nav bar
    menu: 'nav/navigation.ejs',
};
   
// Whizzoh is the default CSS 
let styleSource = pwaRoot + 'styles/highlights/highlight_whizzoh.css';
const brandName = pwaBrand.toLowerCase();

// Only add custom CSS to brands with white-labeling enabled
if (typeof activeBrand.whitelabel === "undefined" || ( typeof activeBrand.whitelabel !== "undefined" && activeBrand.whitelabel === true) )
{
    let clientFolder = brandName;
    switch(brandName)
    {
        // Outsurance
        case 'outsurance':
            clientFolder = 'outsuranceV2';
            break;
    }

    styleSource = pwaDomain + 'client/' + clientFolder + '/style.css';
}

// Default color schemes
const colorSchemes = {
    whizzoh: {
        primary: '#e96550',
        secondary: '#e96550'
    }
};

// Get current brand's color scheme
let brandColorScheme = {};
const currentScheme = colorSchemes[brandName];
if (currentScheme)
{
    brandColorScheme = currentScheme;
}

// White labeling
let whitelabel = true;
if (activeBrand.whitelabel !== "undefined")
{
    whitelabel = activeBrand.whitelabel;
}

let startUrl = (typeof activeBrand.scheme !== "undefined" && typeof activeBrand.scheme.startUrl !== "undefined") ? pwaRoot+activeBrand.scheme.startUrl : pwaRoot;
let pwaAppName = pwaBrand;
if (pwaBrand == "ignition")
{
    pwaAppName = "SafeBase";
}

const settings = {
    // App settings
    domain: pwaDomain,
    appRoot: pwaRoot,
    pwaStartUrl: startUrl,
    builtAt: +new Date(),
    isPWA: true,                // Switch PWA functionality on/off
    isAJAX: true,               // Used for Swup JS transitions (SPA-like app)
    pwaRemind: 1,               // Number of days when to remind user to install PWA
    pwaNoCache: true,           // Will clear cache on each visit if true
    darkMode: darkMode,         // Turn dark mode feature on/off
    showNewsFeed: showNewsFeed, // Turn news feed on dashboard on/off
    // Auth settings
    rememberMe: 90,             // How long to remember user in days
    // Theme settings
    colorScheme: brandColorScheme,
    // Whether app is white labelled or not
    whitelabel: whitelabel,
    // PWA settings
    pwaScope: pwaRoot,
    pwaBrand: pwaBrand,
    pwaScheme: (typeof activeBrand.scheme !== "undefined") ? activeBrand.scheme : defaultScheme,
    pwaBrandName: pwaBrandName,
    pwaBrandStylesheet: styleSource,
    pwaName: pwaAppName + ' ' + pwaType,
    pwaBrandType: pwaType,
    pwaDescription: pwaDescription,
    // Services
    services: {
        dbSurge: activeBrand.serviceDbSurge
    },
    // SwupJS
    swupLinkSelector: 'a[href]:not([href^="tel:"]):not([href="#"]):not([class^="fc-"]):not(.external-link):not(.default-link):not([href^="https"]):not([href^="http"]):not([data-gallery])',
    // App templates
    templates: {
        // Views
        views: {
            index: {
                template: 'views/home.html',
                offCanvas: [
                    offCanvasTemplates.termsConditions,
                    offCanvasTemplates.serviceRequestMenus
                ],
                filename: 'index.html',
                title: `${pwaBrandNameCaps} Services`,
            },
            about: {
                template: 'views/about.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [
                    offCanvasTemplates.termsConditions
                ],
                title: 'About - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            dashboard: {
                template: 'views/dashboard.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [],
                title: 'Home - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            jobs: {
                template: 'views/jobs.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [],
                title: 'Jobs - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            job: {
                template: 'views/job.html',
                navigation: 'nav/header-back.ejs',
                navigationUrl: 'jobs.html',
                offCanvas: [
                    offCanvasTemplates.bidMenus,
                    offCanvasTemplates.paymentFrame,
                    offCanvasTemplates.paymentMenu,
                    offCanvasTemplates.quoteMenus,
                    offCanvasTemplates.chatMenus,
                    offCanvasTemplates.jobRatingMenus,
                    offCanvasTemplates.termsConditions,
                    offCanvasTemplates.invoiceMenus
                ],
                title: 'Job - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            jobCancel: {
                template: 'views/job-cancel.html',
                navigation: 'nav/header-back.ejs',
                navigationUrl: 'job.html',
                offCanvas: [
                    offCanvasTemplates.jobMenus,
                    offCanvasTemplates.termsConditions,
                    offCanvasTemplates.jobRatingMenus,
                ],
                title: 'Cancel job - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            jobNew: {
                template: 'views/job-new.html',
                navigation: 'nav/header-back.ejs',
                navigationUrl: 'jobs.html',
                offCanvas: [
                    offCanvasTemplates.jobMenus,
                    offCanvasTemplates.assessmentMenus,
                ],
                title: 'Create a new job - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            address: {
                template: 'views/address-list.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [],
                title: 'Addresses - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            addressEdit: {
                template: 'views/address-edit.html',
                navigation: 'nav/header-back.ejs',
                navigationUrl: 'address-list.html',
                offCanvas: [
                    offCanvasTemplates.endUserAddressMenus
                ],
                title: 'Job - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            addressNew: {
                template: 'views/address-new.html',
                navigation: 'nav/header-back.ejs',
                navigationUrl: 'address-list.html',
                offCanvas: [
                    offCanvasTemplates.endUserAddressMenus
                ],
                title: 'Add a new address - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            support: {
                template: 'views/support.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [],
                title: 'Support - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            inbox: {
                template: 'views/inbox.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [
                    offCanvasTemplates.inboxMenus,
                    offCanvasTemplates.invoiceMenus
                ],
                title: 'Inbox - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            personalDetails: {
                template: 'views/personal-details.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [
                    offCanvasTemplates.termsConditions
                ],
                title: 'Personal details - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            manageCards: {
                template: 'views/manage-cards.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [
                    offCanvasTemplates.bankCardMenus
                ],
                title: 'Manage cards - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            password: {
                template: 'views/password.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [],
                title: 'Change your password - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            // Dev page
            images: {
                template: 'views/images.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [],
                title: 'Service Images - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            // Chat page for iframe (Nanny)
            chat: {
                template: 'views/chat.html',
                offCanvas: [],
                title: 'Chat - ' + pwaBrandNameCaps + ' Services',
                mainMenu: offCanvasTemplates.menu
            },
            termsConditions: {
                template: 'views/terms-conditions.html',
                offCanvas: [],
                title: 'Terms and conditions - ' + pwaBrandNameCaps + ' Services'
            },
            invoice: {
                template: 'views/invoice.html',
                offCanvas: [],
                title: 'Invoice - ' + pwaBrandNameCaps + ' Services'
            },
            serviceRequest: {
                template: 'views/service-request.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [
                    offCanvasTemplates.serviceRequestMenus
                ],
                filename: 'service-request.html',
                title: `Service Request - ${pwaBrandNameCaps} Services`,
            },
        },
        globalComponents: {
            offCanvas: [
                offCanvasTemplates.globalMenus,
                offCanvasTemplates.notifications,
                offCanvasTemplates.unsignedDocs
            ] 
        }
    },

    // Dependancies
    dependancies: {
        mapbox: [
            'job-new',
            'address-new',
            'address-edit'
        ],
        pica: [
            'job-new'
        ],
        firebase: [
            'job'
        ],
        glightbox: [
            'job'
        ],
    }
}

// Make settings read-only
for( let key in settings)
{
    Object.defineProperty(settings, key, {
        value: settings[key], 
        writable: false
    });
};

function getBrand(pwaBrand, allBrands)
{
    let brandName = pwaBrand.toLowerCase();
    if ( typeof allBrands[brandName] == "undefined" )
    {
        return null;
    }
    return allBrands[brandName];
}
 
module.exports = {
    settings
};